import styled from "styled-components";

export const OfferContainer = styled.div`
  background: #4c5065;
  position: relative;
  z-index: 1;
  offset: -80px;
`;

export const OfferContent = styled.div`
    display:grid;
    width:100%;
    min-height:800px;
    padding 0 30px;
    grid-auto-columns: minmax(auto, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;

 
    grid-template-areas: 'col1 col2'   ;

    @media screen and (max-width: 768px) {
      grid-template-areas:'col1' 'col2' ;
        
`;

export const OfferBtnArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-area: col1;
`;

export const OfferScreenArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  grid-area: col2;
`;

export const OfferBtnPlace = styled.button`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  width: 300px;
  background: #fff;
  border-radius: 50px;
  padding: 5px;
  outline: none;
  border: none;
  cursor: pointer;
  border: 2px solid blue;
  font-size: 20px;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    text-decoration: underline;
  }
`;

export const BaseballBtn = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`;
export const KidBtn = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const KaszkietBtn = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const SyntheticBtn = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const OtherBtn = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`;
export const PinBtn = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const Screen = styled.div`
  max-width: 100vw;
`;
